var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.505 11.66a3.024 3.024 0 00-2.115-2.14C25.512 9 18 9 18 9s-7.512 0-9.39.5c-1.009.28-1.84 1.12-2.116 2.16C6 13.56 6 17.5 6 17.5s0 3.96.494 5.84a3.025 3.025 0 002.116 2.14C10.507 26 18 26 18 26s7.512 0 9.39-.5a3.025 3.025 0 002.116-2.14c.494-1.9.494-5.84.494-5.84s.02-3.96-.495-5.86zm-13.897 9.48v-7.28l6.247 3.64-6.247 3.64z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
};

export default __webpack_public_path__ + "static/media/youtube.6591b687.svg";
export { SvgYoutube as ReactComponent };